import { DateTime } from 'luxon';
import { fromJsonArray } from 'src/core/utils';
import CustomerMailAddress from 'src/entities/customer/CustomerMailAddress';
import CustomerPhoneNumber from 'src/entities/customer/CustomerPhoneNumber';
import OrgCustomerPremiumLevel from '../organization/OrgCustomerPremiumLevel';

export default class CustomerData {
    public readonly id: number;
    public readonly firstName: string;
    public readonly lastName: string;
    public readonly email: string;
    public readonly phoneNumber: string;
    public readonly userType: 'Partner' | 'Customer';
    public readonly premiumRecommendationUrl: string;
    public readonly recommendationUrl?: string;
    public readonly recommenderFirstName?: string;
    public readonly recommenderLastName?: string;
    public readonly languageIso2?: string;
    public readonly timeZone?: string;
    public readonly note?: string;
    public readonly refPartnerId?: string;
    public readonly refPartnerName?: string;
    public readonly availableCredit: number;
    public readonly currencyIso: string;
    public readonly refId?: string;
    public readonly refName?: string;
    public readonly validFrom?: DateTime;
    public readonly accountMailAddressId?: string;
    public readonly accountPhoneNumberId?: string;
    public readonly newsletterMailAddressId?: string;
    public readonly mailAddresses: CustomerMailAddress[];
    public readonly phoneNumbers: CustomerPhoneNumber[];
    public readonly documentsRequiredCount: number;
    public readonly premiumLevel: number;
    public readonly minPremiumLevel: number;
    public readonly landingPageEnabled: boolean;
    public readonly premiumLevelUntil?: DateTime;
    public readonly premiumLevelOrders: number;
    public readonly customerPremiumLevels?: OrgCustomerPremiumLevel[];

    constructor(json: any) {
        this.id = json.id;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.userType = json.userType;
        this.email = json.email;
        this.phoneNumber = json.phoneNumber;
        this.userType = json.userType;
        this.premiumRecommendationUrl = json.premiumRecommendationUrl;
        this.recommendationUrl = json.recommendationUrl;
        this.recommenderFirstName = json.recommenderFirstName ?? undefined;
        this.recommenderLastName = json.recommenderLastName ?? undefined;
        this.languageIso2 = json.languageIso2;
        this.timeZone = json.timeZone;
        this.note = json.note;
        this.refPartnerId = json.refPartnerId;
        this.refPartnerName = json.refPartnerName;
        this.availableCredit = json.availableCredit ?? 0;
        this.currencyIso = json.currencyIso || 'EUR';
        this.refId = json.refId ?? undefined;
        this.refName = json.refName ?? undefined;
        this.validFrom = json.validFrom ? DateTime.fromISO(json.validFrom) : undefined;
        this.accountMailAddressId = json.accountMailAddressId ?? undefined;
        this.accountPhoneNumberId = json.accountPhoneNumberId ?? undefined;
        this.newsletterMailAddressId = json.newsletterMailAddressId ?? undefined;
        this.mailAddresses = fromJsonArray(CustomerMailAddress, json.mailAddresses);
        this.phoneNumbers = fromJsonArray(CustomerPhoneNumber, json.phoneNumbers);
        this.documentsRequiredCount = json.documentsRequiredCount;
        this.premiumLevel = json.premiumLevel;
        this.minPremiumLevel = json.minPremiumLevel;
        this.landingPageEnabled = json.landingPageEnabled ?? false;
        this.premiumLevelUntil = json.premiumLevelUntil ? DateTime.fromISO(json.premiumLevelUntil) : undefined;
        this.premiumLevelOrders = json.premiumLevelOrders ?? 0;
        this.customerPremiumLevels = json.customerPremiumLevels ?? [];
    }

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }

    get hasCreditAvailable(): boolean {
        return this.availableCredit > 0;
    }
}
